module.exports = __webpack_public_path__ + "static/img/wood81.1a69fa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood81.jpg
// module id = c4Oi
// module chunks = 0